import { SxProps, Theme } from "@mui/material/styles";

const styles: Record<string, SxProps<Theme>> = {
  table: {
    "& .MuiTableCell-root": {
      p: "12px",
      fontSize: "14px",
      fontWeight: 500,
      color: "#25282D"
    },

    "& .MuiTableRow-head .MuiTableCell-root": {
      p: "15px 12px",
    }
  },
  headRow: {
    verticalAlign: "baseline",
    backgroundColor: "#F7F9FB"
  }
};

export default styles;
